import { TFormValidationResult } from 'cng-common/features/form/models'
import { isValidKeyInitiativeFinancialTarget } from 'partner360/features/keyInitiativeEditor/lib/keyInitiativeFinancialTarget'

interface IValidateKeyInitiativeEstimateSalesParams {
  field: string
  value: number | null | undefined
  isRequired: boolean
}

export const validateKeyInitiativeEstimateSales = ({
  field,
  value,
  isRequired,
}: IValidateKeyInitiativeEstimateSalesParams): TFormValidationResult | undefined => {
  if (!isRequired) {
    return undefined
  }

  return isValidKeyInitiativeFinancialTarget(value)
    ? undefined
    : { field, message: 'Field must not be empty' }
}
